import { h, VNode } from 'preact';
import { AppStoreLinks } from './AppStoreLinks';

interface ErrorViewProps {
  errorMessage: string | null;
}

export function ErrorView({
  errorMessage,
}: ErrorViewProps): VNode {
  return (
    <div className="container">
      <div className="subhead" id="errorText">
        {errorMessage}
      </div>

      <div className="subhead">
        Find more events:
      </div>

      <AppStoreLinks />

      <img
        src="https://uploads-ssl.webflow.com/604e5bf6813f947d0e60c30d/621b704ca8b443366a377c7d_nightli%20vit-09.svg"
        width="150"
        height="100"
        loading="lazy"
        alt="nightli my social nightlife app"
      />
    </div>
  );
}
